import { LOCAL_PREVIEW } from '../../localPreview';

export default function AdminLogin({ busy, onSubmit, status }) {
  return (
    <main className="admin-page admin-login-page">
      <form className="admin-login" onSubmit={onSubmit}>
        <p className="admin-kicker">Website management</p>
        <h1>Admin login</h1>
        {LOCAL_PREVIEW && <p>Local account: <strong>admin@local.test</strong><br />Password: <strong>local-preview-only</strong></p>}
        <p className="admin-login-intro">Sign in to update site content, audience data, and approved media.</p>
        <label>Email<input name="email" type="email" autoComplete="username" required /></label>
        <label>Password<input name="password" type="password" autoComplete="current-password" required /></label>
        {status.message && <p className={`admin-message ${status.type}`} role="alert">{status.message}</p>}
        <button className="admin-primary" disabled={busy} data-busy={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <a className="admin-back-link" href="/">← Return to website</a>
      </form>
    </main>
  );
}
